
import { Heading } from '@chakra-ui/react';
import BankAccountRoutingFormHandle from '../../containers/forms/base/bankAccountRouting/BankAccountRoutingFormHandle';

const BankAccountRoutingPage = () => {
  return (
    <>
      <Heading size="md" mb={"2rem"}>Bank Account Routing Rules</Heading>
      <BankAccountRoutingFormHandle />
    </>
  );
};

export default BankAccountRoutingPage;
